<template>
  <section
    class="accordion-item"
    :class="{
      'accordion-item--expanded': visible,
      'border-b border-base-30': hasDefaultStyling && hasBottomBorder,
    }"
  >
    <div
      class="accordion-item-title"
      :class="{'border-l-4 border-transparent': hasDefaultStyling }"
      @click="toggle"
    >
      <div
        class="accordion-item-title-content"
        :class="{'justify-between p-4': hasDefaultStyling }"
      >
        <slot name="title" />
        <aha-icon
          class="accordion-item-icon"
          name="arrow"
          viewBox="0 0 24 24"
          width="12"
          height="12"
        />
      </div>
    </div>
    <div
      class="accordion-item-content"
      :class="{ 'border-l-4 border-transparent mt-4': hasDefaultStyling }"
      v-if="visible"
    >
      <div
        class="flex flex-col"
        :class="{'p-4 pt-0': hasDefaultStyling }"
      >
        <slot name="content" />
      </div>
    </div>
  </section>
</template>

<script>
import AhaIcon from '../Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  props: {
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
    hasDefaultStyling: {
      type: Boolean,
      default: true,
    },
    hasBottomBorder: {
      type: Boolean,
      default: true,
    },
    onToggle: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      visible: this.defaultExpanded,
    }
  },
  created() {
    this.$parent.addAccordion(this)
  },
  methods: {
    toggle() {
      this.$parent.closeAllAccordionsExceptActiveOne(this)
      this.visible = !this.visible
      if (this.onToggle) this.onToggle(this.visible)
    },
    setInvisible() {
      this.visible = false
    },
  },
}
</script>
ßß
<style lang="scss" scoped>
.accordion-item-title {
  @apply cursor-pointer;
  @apply transition text-base-90;
}

.accordion-item-title-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.accordion-item--expanded > .accordion-item-title {
  @apply border-primary-90 text-secondary-100 font-bold;
}

.accordion-item:hover > .accordion-item-title {
  @apply border-primary-90;
}

.accordion-item .accordion-item-icon {
  @apply transition transform -rotate-90;
}

.accordion-item--expanded .accordion-item-icon {
  @apply rotate-0;
}
</style>
